customElements.define(
  'push-cart-item',
  class PushCartItem extends window.BAO.CustomElement {
    _loading = false
    sections = window.BAO.utils.sectionRenderer.pushCartSections

    setupListeners () {
      super.setupListeners()

      this.removeLineItem = this.removeLineItem.bind(this)
      this.updateQuantity = this.updateQuantity.bind(this)

      if (this.els?.remove?.exists) {
        this.listeners.add(
          this.els.remove.element,
          'click',
          this.removeLineItem,
        )
      }

      if (this.els?.quantity?.exists) {
        this.listeners.add(
          this.els.quantity.element,
          'change',
          this.updateQuantity,
        )
      }
    }

    async removeLineItem (e) {
      const state = await window.BAO.Cart.removeItem(
        this.line,
        this.sections.map(s => s.section),
      )

      const item = e.target.closest('.psh-CartItem')
      const linkedItem = window.BAO.utils
        .getElements('.psh-CartItem')
        .find(cartItem => {
          return (
            cartItem.dataset.childId === item.dataset.parentId &&
            cartItem.dataset.childId !== undefined &&
            item.dataset.parentId !== undefined
          )
        })

      document.querySelector(
        '.psh-Cart_Title',
      ).innerHTML = document.querySelector(
        '.psh-Cart_Title',
      ).dataset.backupTitle

      if (linkedItem) {
        const state = await window.BAO.Cart.removeItem(
          linkedItem.getAttribute('index'),
          this.sections.map(s => s.section),
        )
        if ('sections' in state) this.renderSections(state.sections)
      } else {
        if ('sections' in state) this.renderSections(state.sections)
      }
    }

    async updateQuantity (e) {
      const state = await window.BAO.Cart.updateQuantity(
        this.line,
        parseInt(e.target.value, 10),
        this.sections.map(s => s.section),
      )

      const item = e.target.closest('.psh-CartItem')
      const linkedItem = window.BAO.utils
        .getElements('.psh-CartItem')
        .find(cartItem => {
          return (
            cartItem.dataset.childId === item.dataset.parentId &&
            cartItem.dataset.childId !== undefined &&
            item.dataset.parentId !== undefined
          )
        })

      if (linkedItem) {
        const state = await window.BAO.Cart.updateQuantity(
          linkedItem.getAttribute('index'),
          parseInt(e.target.value, 10),
          this.sections.map(s => s.section),
        )
        if ('sections' in state) this.renderSections(state.sections)
      } else {
        if ('sections' in state) this.renderSections(state.sections)
      }
    }

    get loading () {
      return this._loading
    }

    set loading (val) {
      this._loading = val
    }

    get line () {
      return parseInt(this.getAttribute('index'), 10)
    }
  },
)
